<script>

	import './style.scss'

	export default {
		name: 'bottom-footer',
	}

</script>

<template>
	<footer class='footer'>
		<div class='copyright'>
			<ul>
				<li>
					<a href='/' class='copyright'>© Daily Coding Problem 2019</a>
				</li>
				<li>
					<a href='/privacy' class='copyright'>Privacy Policy</a>
				</li>
				<li>
					<a href='/terms-of-service' class='copyright'>Terms of Service</a>
				</li>
				<li>
					<a href='/press' class='press'>Press</a>
				</li>
			</ul>
		</div>
	</footer>
</template>



// WEBPACK FOOTER //
// src/components/BottomFooter/BottomFooter.vue